const FEATURE_ITEMS = [
  {
    title: '极速播放',
    desc: '全球 CDN 加速节点覆盖，智能码率自适应，确保高清流畅不卡顿的观影体验。',
    icon: 'ri-speed-up-line',
  },
  {
    title: '海量资源',
    desc: '聚合多平台优质内容，涵盖影视、综艺、动漫、短视频等多元分类，每日更新超 300 部。',
    icon: 'ri-database-2-line',
  },
  {
    title: '全端适配',
    desc: 'Web、iOS、Android 全平台覆盖，支持 Chromecast 投屏，随时随地享受大屏观影。',
    icon: 'ri-device-line',
  },
  {
    title: '安全纯净',
    desc: '无弹窗广告、无恶意跳转，所有内容经过安全审核，为用户打造绿色健康的观影环境。',
    icon: 'ri-shield-check-line',
  },
];

const UPDATE_ITEMS = [
  { title: '平台新增 4K 超清专区，精选内容支持高画质播放', time: '07-30', tag: '更新' },
  { title: 'APP 4.0 版本上线，全新智能推荐引擎大幅提升', time: '07-28', tag: '版本' },
  { title: '动漫频道新增 200+ 部经典番剧，一站式怀旧体验', time: '07-27', tag: '上新' },
  { title: '服务器全面升级完成，播放加载速度提升 40%', time: '07-25', tag: '优化' },
  { title: '短视频创作者入驻计划启动，开放独家流量扶持', time: '07-23', tag: '招募' },
  { title: '纪录片专区上线 BBC、NHK 正版授权精品内容', time: '07-21', tag: '引进' },
  { title: '用户反馈系统全面改版，意见提交更便捷高效', time: '07-19', tag: '功能' },
];

export default function FeaturesUpdatesSection() {
  return (
    <>
      {/* #features */}
      <section id="features" className="py-16 md:py-24 px-4 md:px-6 bg-background-50">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4">
              <i className="ri-star-line text-sm"></i>
              平台优势
            </div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
              为什么选择榴莲视频
            </h2>
            <p className="text-sm text-foreground-600 mt-2 max-w-md mx-auto">
              四大核心优势，打造极致观影体验
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {FEATURE_ITEMS.map((item, idx) => (
              <div
                key={idx}
                className="p-6 rounded-2xl bg-background-100 border border-background-200/60 text-center hover:-translate-y-1 transition-all duration-300 cursor-pointer"
              >
                <div className="w-14 h-14 rounded-2xl bg-primary-100 flex items-center justify-center mx-auto mb-4">
                  <i className={`${item.icon} text-primary-500 text-2xl`}></i>
                </div>
                <h3 className="font-medium text-foreground-950 text-base mb-2">{item.title}</h3>
                <p className="text-xs text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* #updates */}
      <section id="updates" className="py-16 md:py-24 px-4 md:px-6 bg-background-100">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
              <i className="ri-timer-line text-sm"></i>
              动态快讯
            </div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
              平台最新动态
            </h2>
            <p className="text-sm text-foreground-600 mt-2 max-w-md mx-auto">
              关注榴莲视频的发展与变化
            </p>
          </div>

          <div className="relative">
            {/* Timeline line */}
            <div className="absolute left-[23px] top-2 bottom-2 w-px bg-background-300/60 hidden sm:block"></div>

            <div className="space-y-5">
              {UPDATE_ITEMS.map((item, idx) => (
                <div key={idx} className="flex gap-4">
                  {/* Dot */}
                  <div className="hidden sm:flex w-12 shrink-0 justify-center relative">
                    <div className="w-3 h-3 rounded-full bg-primary-500 mt-1.5 z-10 ring-4 ring-background-100"></div>
                  </div>

                  {/* Content */}
                  <div className="flex-1 bg-background-50 rounded-xl border border-background-200/60 p-4 hover:-translate-y-0.5 transition-all duration-200 cursor-pointer">
                    <div className="flex items-start gap-3">
                      <div className="flex-1 min-w-0">
                        <h3 className="text-sm font-medium text-foreground-950 mb-1">{item.title}</h3>
                        <div className="flex items-center gap-3">
                          <span className="text-xs text-foreground-500">{item.time}</span>
                          <span className="px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium">
                            {item.tag}
                          </span>
                        </div>
                      </div>
                      <div className="text-foreground-400 shrink-0 mt-1">
                        <i className="ri-arrow-right-line"></i>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}